/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestRelatedApplicationsOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestRelatedApplicationsOptions(value) {
    if (!('Platform' in value) || value['Platform'] === undefined)
        return false;
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON(json) {
    return FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Platform': json['platform'],
        'Url': json['url'],
        'Id': json['id'] == null ? undefined : json['id'],
    };
}
export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON(json) {
    return FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'platform': value['Platform'],
        'url': value['Url'],
        'id': value['Id'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayManifestRelatedApplicationsOptions.js.map